// User-facing copy: newClub. Moved from the web app (components/Bookplate.tsx, pages/NewClub.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** components/Bookplate.tsx */
export const bookplate = {
    exLibris: "Ex libris",
    yourClub: "Your club",
    firstUp: "First up: ",
};
/** pages/NewClub.tsx */
export const page = {
    youAlreadyRunFive: "You already run five clubs",
    thatSTheMost: "That's the most one person can own. To start another, hand one of yours to another member, or delete one, from its Club settings.",
    backToYourClubs: "Back to your clubs",
    you: "You",
    aboutPagesADay: (usualPace) => `About ${usualPace} pages a day`,
    firstUp: (title) => `First up: ${title}`,
    close: "Close",
    newClub: "New club",
    stepOf: (x, length) => `Step ${x} of ${length}`,
    back: "Back",
    goToYourClub: "Go to your club",
    creating: "Creating…",
    createClub: "Create club",
    next: "Next",
    pickedByAdmins: "Picked by admins",
    pickedByVote: "Picked by vote",
    pickedInTurns: "Picked in turns",
    nameYourClub: "Name your club",
    aClubReadsOne: "A club reads one book at a time and talks about it without spoilers. You can change any of this later.",
    clubName: "Club name",
    eGTuesdayPages: "e.g. Tuesday Pages",
    giveYourClubA: "Give your club a name.",
    link: "Link",
    clubs: (host) => `${host}/clubs/`,
    done: "Done",
    useOneFromThe: "Use one from the name",
    changeTheLink: "Change the link",
    available: "✓ Available",
    anotherClubHasThat: "Another club has that link.",
    linksNeed3To: "Links need 3 to 40 letters, numbers or hyphens.",
    use: (suggestion) => `Use ${suggestion}`,
    description: "Description",
    fantasyMostlySnacksMandatory: "Fantasy, mostly. Snacks mandatory.",
    oneLineShownTo: "One line. Shown to members and people you invite.",
    whatDoYouRead: "What do you read?",
    pickUpToFive: "Pick up to five. Members and people you invite will see them.",
    howThisClubWorks: "How this club works ",
    optional: "(optional)",
    howOftenYouMeet: "How often you meet, what you tend to read.",
    howYouReadTogether: "How you read together",
    everyoneReadsAtTheir: "Everyone reads at their own speed.",
    hideSpoilers: "Hide spoilers",
    eachCommentIsPinned: "Each comment is pinned to how far its writer had read. You only see comments up to your own page.",
    usualPace: "Usual pace",
    roughlyHowManyPages: "Roughly how many pages a day. People see it before they join.",
    a300PageBook: (spanFor) => `A 300-page book takes ${spanFor}.`,
    day: "day",
    days: "days",
    aboutWeeks: (round) => `about ${round} weeks`,
    example: "Example",
    theFirstChapterHooked: "The first chapter hooked me.",
    iDidNotSee: "I did not see that ending coming.",
    choosesTheNextBook: (owner) => `${owner} chooses the next book from the members' suggestions. You can switch to a vote as the club grows.`,
    everyoneVotesBetweenThe: "Everyone votes between the suggestions the club most wants to read; the favourite is read next.",
    picksFirstThenWhoever: (owner) => `${owner} picks first, then whoever joined next, and so on.`,
    pickingTheNextBook: "Picking the next book",
    membersSuggestBooksThis: "Members suggest books; this is how one gets chosen.",
    howItGetsPicked: "How it gets picked",
    howTheNextBook: "How the next book gets picked",
    adminsPick: "Admins pick",
    vote: "Vote",
    takeTurns: "Take turns",
    whoCanSuggest: "Who can suggest",
    whoCanPutBooks: "Who can put books forward.",
    whoCanFindThis: "Who can find this club?",
    youCanChangeThis: "You can change this later. Invite links work in every mode.",
    clubsPeopleCanFind: "Clubs people can find need a one-line description.",
    whatAreYouReading: "What are you reading first?",
    optionalItBecomesThe: "Optional. It becomes the club's book straight away, so everyone lands on it. You can also choose one later.",
    change: "Change",
    skipForNow: "Skip for now",
    isReady: (name) => `${name} is ready`,
    inviteYourFirstMembers: "Invite your first members.",
    makingALink: "Making a link",
    copied: "Copied",
    copy: "Copy",
    share: "Share…",
    thisLinkWorksFor: "This link works for 7 days. You can make new links any time.",
    about: (days, x) => `about ${days} ${x}`,
    everyone: "Everyone",
    admins: "Admins",
};
//# sourceMappingURL=newClub.js.map